import { ifAuthenticated } from "@/router";

export default [
  {
    path: "/surveys",
    name: "surveysIndex",
    beforeEnter: ifAuthenticated,
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/surveys/Index.vue")
  },

  {
    path: "/surveys/:surveyId/edit",
    name: "surveysEdit",
    beforeEnter: ifAuthenticated,
    component: () =>
      import(/* webpackChunkName: "facility" */ "@/views/surveys/Edit.vue")
  },

  {
    path: "/survey-responses",
    name: "surveysResponses",
    beforeEnter: ifAuthenticated,
    component: () =>
      import(/* webpackChunkName: "facility" */ "@/views/surveys/Responses.vue")
  },

  {
    path: "/survey-responses/:surveyId/response",
    name: "surveysResponse",
    beforeEnter: ifAuthenticated,
    component: () =>
      import(/* webpackChunkName: "facility" */ "@/views/surveys/SurveyResponse.vue")
  }
];
